import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';

const ShumaType3Line1 = React.forwardRef(({}, ref) => {
  return (
    <div className={classnames(styles.itemText, styles.innerPadding)} ref={ref}>
      <span className={styles.bold}>השימוש בנכס: </span>
      <span>
         למגורים.
      </span>
    </div>
  )
});

ShumaType3Line1.propTypes = {

};

export default ShumaType3Line1;
